__turbopack_context__.v({
  "chevron": "ToolbarDropdown-module__MIgnFq__chevron",
  "chevronOpen": "ToolbarDropdown-module__MIgnFq__chevronOpen",
  "container": "ToolbarDropdown-module__MIgnFq__container",
  "dropdownContent": "ToolbarDropdown-module__MIgnFq__dropdownContent",
  "fallbackLabel": "ToolbarDropdown-module__MIgnFq__fallbackLabel",
  "popover": "ToolbarDropdown-module__MIgnFq__popover",
  "popoverTrigger": "ToolbarDropdown-module__MIgnFq__popoverTrigger",
});
